import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { ConfirmDialogModule } from './../../dialogs/confirm-dialog/confirm-dialog.module';
import { ProtectedControlsDialogComponent } from './protected-controls-dialog.component';

@NgModule({
  declarations: [ProtectedControlsDialogComponent],
  entryComponents: [ProtectedControlsDialogComponent],
  exports: [ProtectedControlsDialogComponent],
  imports: [ConfirmDialogModule, I18nModule, CommonModule],
})
export class ProtectedControlsDialogModule {}
export { ProtectedControlsDialogComponent } from './protected-controls-dialog.component';
